import { useState, useEffect } from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { api } from "../../utils/apiClient"; // your axios instance
import { toast } from "react-toastify";
import useExportSignature from "../../hook/useExportSignature";
import ContentLoader from "../../utils/ContentLoader";
import { useSelector } from "react-redux";


const SettingsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "warrant";
    const [settingData, setSettingData] = useState(null); // start null to detect loading

    const exportSignature = useExportSignature();
    const [loading, setLoading] = useState(false);
    const handleTabChange = (key) => setSearchParams({ tab: key });
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];

    // console.log("settingData=================", settingData)

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const response = await api.get("/settings");
            setSettingData(response.data.data || {});
            setLoading(false);
        } catch (err) {
            console.error("Failed to fetch settings", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    // Check if a value is a blob (signature from canvas)
    const isBlobUrl = (url) => typeof url === "string" && url.startsWith("blob:");

    // Append blob file if present
    const appendFileIfBlob = async (formData, blobUrl, fieldName, defaultName) => {
        if (isBlobUrl(blobUrl)) {
            const file = await exportSignature(blobUrl, defaultName);
            formData.append(fieldName, file);
            return file;
        }
        return null;
    };

    const fixSpareDescriptions = (spare_descriptions) => ({
        parts: (spare_descriptions.parts || []).map(i => ({ ...i, tag: Boolean(i.tag) })),
        nett: (spare_descriptions.nett || []).map(i => ({ ...i, tag: Boolean(i.tag) })),
        labour: (spare_descriptions.labour || []).map(i => ({ ...i, tag: Boolean(i.tag) })),
    });

    const handleChange = (updatedData) => {
        // Merge child form updates
        setSettingData((prev) => ({ ...prev, ...updatedData }));
    };

    const handleSubmit = async () => {
        if (!settingData) return;
        setLoading(true);

        try {
            const formData = new FormData();

            // ✅ build correct payload ONCE
            const fixedPayload = {
                ...settingData,
                spare_descriptions: fixSpareDescriptions(settingData.spare_descriptions),
            };

            // remove file fields
            const { ownerSignatureUrl, ownerStampUrl, ...payload } = fixedPayload;

            // append JSON
            formData.append("settings", JSON.stringify(payload));

            // append files
            await appendFileIfBlob(formData, settingData.ownerSignatureUrl, "company_owner_signature", "ownerSignature.png");
            await appendFileIfBlob(formData, settingData.ownerStampUrl, "company_stamp", "ownerStamp.png");

            formData.append("common_claim_logo", settingData.common_claim_logo);
            formData.append("rental_logo", settingData.rental_logo);

            await api.post("/settings", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            toast.success("Settings saved successfully");
            await fetchSettings();

        } catch (err) {
            console.error(err);
            toast.error(err?.response?.data?.message || "Failed to save settings");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <ContentLoader />;
    // console.log(settingData);

    return (
        <div className="settings-page">
            <Breadcrumb title="Settings" />
            <div className="card">
                <Tabs
                    activeKey={activeTab}
                    className="settings-ant-tabs"
                    onChange={handleTabChange}
                    tabBarGutter={16}
                    more={null} // <--- ADD THIS: Removes the '...' button logic entirely
                    layout="horizontal" // <--- ADD THIS: Forces horizontal layout
                    destroyInactiveTabPane={false}
                    items={[
                        {
                            key: "warrant",
                            label: "Warrant Settings",
                            // children: (
                            //     <WarrantActSettings
                            //         data={settingData}
                            //         onChange={handleChange}
                            //     />
                            // ),
                        }
                    ]}
                />
                <div className="d-flex justify-content-end" style={{ padding: "10px" }}>
                    {viewPermissions.includes("settings.edit") && activeTab !== "partKeyword" && (
                        <button
                            className="btn btn-primary-600"
                            onClick={handleSubmit}
                            style={{
                                borderRadius: "4px",
                                marginRight: "9px",
                                paddingLeft: "17px",
                                paddingRight: "17px"
                            }}
                        >
                            Submit
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};


export default SettingsPage;
